import { render, staticRenderFns } from "./CabeceraVista.vue?vue&type=template&id=43d631bd&v-slot%3Aprepend=true&"
import script from "./CabeceraVista.vue?vue&type=script&lang=js&"
export * from "./CabeceraVista.vue?vue&type=script&lang=js&"
import style0 from "./CabeceraVista.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
